import { useState } from 'react';

const Placeholder = ({ className }) => (
  <div
    className={`flex flex-col items-center justify-center bg-gradient-to-br from-slate-100 via-slate-50 to-blue-50 ${className}`}
  >
    <span className="text-sm font-bold text-slate-400 tracking-wide leading-none">Coming Soon</span>
    <span className="mt-1 text-[10px] font-semibold text-blue-500 tracking-widest uppercase">Casahom.com</span>
  </div>
);

export const ListingImage = ({ src, alt = '', className = '', loading }) => {
  const [errored, setErrored] = useState(false);

  if (!src || src === '/placeholder.jpg' || errored) {
    return <Placeholder className={className} />;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      onError={() => setErrored(true)}
    />
  );
};
